module.exports = __webpack_public_path__ + "c678d9be7aafa5e719c2c52929e0dbe8.MP3";